module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/thurston_promo_custom.985181e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/thurston_promo_custom.jpg
// module id = UTe6
// module chunks = 1